import { Injectable } from '@angular/core';
import { SharedData } from '../interface/sharedData.interface';
import { UserData } from '../interface/userData.interface';
import { BehaviorSubject } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class AppService {
  sharedData = {
    init: 'init',
    status: false,
    title: '',
    subtitle:'',
    user: {} as UserData
  } as SharedData

  private messageSource = new BehaviorSubject<SharedData>(this.sharedData)
  currentMessage = this.messageSource.asObservable()

  constructor() {}
  changeMessage(message:SharedData){
    this.messageSource.next(message)
  }

}
